import variables from '@/assets/scss/exports.scss'

export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    publicationId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    color: variables['webflow-color-blue-dark'],
    list: null,
    errorMessage: null,
    isLoadingAsyncData: false,
  }),
  computed: {
    isContainerVisible() {
      return this.errorMessage || (Array.isArray(this.list) && this.list.length > 0)
    },
  },
  watch: {
    active: {
      handler(v) {
        if (!v) return
        this.getData()
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      return []
    },
    async getData() {
      if (this.list?.length > 0 || !this.publicationId) return

      this.isLoadingAsyncData = true
      this.errorMessage = null

      try {
        this.list = await this.loadData()
      } catch (e) {
        this.errorMessage = e.message
      }

      this.isLoadingAsyncData = false
    },
  },
}
